/*
  EVEROUT HEAD
  ---------
  see webpack.config.js for configuration
*/

import './css/everout.scss';
